"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var compare_arrays_1 = require("../utils/compare-arrays");

var tokens_1 = require("../tokens");

var transactionInfoPattern = new RegExp(['^\\\s*', '([0-9]{2})', '([0-9]{2})', '([0-9]{2})', '([0-9]{2})?', '([0-9]{2})?', '(C|D|RD|RC)', '([A-Z]{1})?', '([0-9]+[,\.][0-9]*)', '([A-Z0-9]{4})?', '([^\/\n\r]{0,16}|NONREF)?', '(\/\/[A-Z0-9]{16})?' // Bank reference
].join(''));
var commaPattern = /,/;
var dotSymbol = String.fromCharCode(tokens_1.dotSymbolCode);
var incomeTransactionCodes = [// ABN AMRO bank
'N653', 'N654', // ING bank
'N060'];
/**
 * @description :61:
 * @type {Uint8Array}
 */

exports.token = new Uint8Array([tokens_1.colonSymbolCode, 54, 49, tokens_1.colonSymbolCode]);
var tokenLength = exports.token.length;
var transactionInfoTag = {
  readToken: function readToken(state) {
    if (!compare_arrays_1.default(exports.token, 0, state.data, state.pos, tokenLength)) {
      return 0;
    }

    return state.pos + tokenLength;
  },
  open: function open(state) {
    var statement = state.statements[state.statementIndex];
    state.transactionIndex++;
    statement.transactions.push({
      id: '',
      code: '',
      fundsCode: '',
      isCredit: false,
      isExpense: true,
      currency: statement.openingBalance.currency,
      description: '',
      amount: 0,
      valueDate: '',
      entryDate: '',
      customerReference: '',
      bankReference: ''
    });
  },
  close: function close(state, options) {
    var statement = state.statements[state.statementIndex];
    var transaction = statement.transactions[state.transactionIndex];
    var content = String.fromCharCode.apply(String, state.data.slice(state.tagContentStart, state.tagContentEnd));

    var _a = transactionInfoPattern.exec(content) || [],
        valueDateYear = _a[1],
        valueDateMonth = _a[2],
        valueDate = _a[3],
        entryDateMonth = _a[4],
        entryDate = _a[5],
        creditMark = _a[6],
        fundsCode = _a[7],
        amount = _a[8],
        code = _a[9],
        customerReference = _a[10],
        bankReference = _a[11];

    if (!valueDateYear) {
      return;
    }

    var year = Number(valueDateYear) > 80 ? "19" + valueDateYear : "20" + valueDateYear;
    transaction.valueDate = year + "-" + valueDateMonth + "-" + valueDate;

    if (entryDateMonth) {
      transaction.entryDate = year + "-" + entryDateMonth + "-" + entryDate;
    }

    transaction.isCredit = creditMark && (creditMark.charCodeAt(0) === tokens_1.bigCSymbolCode || creditMark.charCodeAt(1) === tokens_1.bigCSymbolCode);

    if (fundsCode) {
      transaction.fundsCode = fundsCode;
    }

    if (customerReference && customerReference !== 'NONREF') {
      transaction.customerReference = customerReference;
    }

    if (bankReference && bankReference !== '//NONREF') {
      transaction.bankReference = bankReference.slice(2);
    }

    transaction.amount = parseFloat(amount.replace(commaPattern, dotSymbol));
    transaction.code = code;
    transaction.isExpense = incomeTransactionCodes.indexOf(code) === -1;
    transaction.id = options.getTransactionId(transaction, state.transactionIndex);
  }
};
exports.default = transactionInfoTag;